import { render, staticRenderFns } from "./ProductsBySupplierQuickAdd.vue?vue&type=template&id=2645b02a&"
import script from "./ProductsBySupplierQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsBySupplierQuickAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBySupplierQuickAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports